import { ReactNode, useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Toolbar, AppBarProps } from '@mui/material';

// project import
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';


// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const RestrictedHeader = () => {
  const theme = useTheme();

  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  // common header
  const mainHeader: ReactNode = (
    <Toolbar>
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar: AppBarProps = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      zIndex: 1200,
      width: '100%'
    }
  };
  
  return (
    <>
        <AppBarStyled {...appBar}>
          {mainHeader}
        </AppBarStyled>
    </>
  );
};

export default RestrictedHeader;
